module.exports = __webpack_public_path__ + "static/media/restart.c6589b35.png";